import { Translation, Translator } from '@morningtrain/react-translations'
import React from 'react'
import * as Displays from 'support/displays'
import { WhenModelValue } from '@morningtrain/react-resources'
import { useField } from '@morningtrain/react-fields'
import * as UI from 'ui'

export default function ImageUpload (props) {
  const {
    name = 'image'
  } = props

  const handleUpload = () => {
    console.log('Clicked image, handle image upload here')
  }

  const field = useField(props)
  const fromName = props.fromName || name

  return field.wrap((fieldProps) => (
    <Translator namespace='generic.fields.image'>

      <div className='hidden'>
        <input
          id={field.id}
          name={field.name}
          type='file'
          onBlur={field.onBlur}
          onFocus={field.onFocus}
          onChange={e => field.onChange(e.target.value)}
          accept={props.accept}
          {...fieldProps}
        />
      </div>

      <label htmlFor={field.id}>
        <div onClick={handleUpload}>
          <WhenModelValue name={fromName} condition={null}>
            <UI.Text color='black'>
              <Translation name='placeholder_text' />
            </UI.Text>
          </WhenModelValue>
          <WhenModelValue name={fromName} condition={null} negate>
            <Displays.Image name={fromName} />
            <UI.Text color='black'>
              <Translation name='subtitle' />
            </UI.Text>
          </WhenModelValue>
        </div>
      </label>
    </Translator>
  ))
}
